import { IconButton, Link, List, ListItemButton, ListItemText } from "@mui/material"
import { Menu } from "@mui/icons-material"
import Drawer from '@mui/material/Drawer'
import { useState } from "react"

export function SideDrawer() {
  const [openDrawer, setOpenDrawer] = useState(false)
  return (
    <div>
      <IconButton onClick={()=>setOpenDrawer(true)}>
        <Menu/>
      </IconButton>
      <Drawer anchor="right" open={openDrawer} onClose={() => setOpenDrawer(false)}>
        <nav className="p-8">
          <ul className="flex flex-col gap-4">
            <li><Link href='#introduction'>サービス紹介</Link></li>
            <li><Link href='#blog'>お役立ち情報</Link></li>
            <li><Link href='#faq'>よくある質問</Link></li>
          </ul>
        </nav>
      </Drawer>
    </div>
  )
}